import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaExternalLinkAlt } from 'react-icons/fa';
function Tab5({ deliveryNoteData, deliveryNoteItems }) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    
    const shipmentId = deliveryNoteData?.custom_shipment_reference;
    if (shipmentId) {
      
      navigate(`/outbound/shippinglist-view/`, { state: { shipment_id: shipmentId } });

    }
  };

  return (
    <div style={{ padding: '16px 24px' }}>
      <div
        className="row"
        style={{
          border: "1px solid #00000059",
          borderRadius: "5px",
          marginBottom: "20px",
          cursor: 'pointer'
        }}
        onClick={handleNavigate}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Shipment Details</p>
<p className="d-flex align-items-center text-primary">
  {deliveryNoteData?.custom_shipment_reference ? (
    <>
      {deliveryNoteData.custom_shipment_reference}
      <FaExternalLinkAlt size={12} className="ms-1" />
    </>
  ) : (
    <span className="text-muted">Shipment Details Not Available</span>
  )}
</p>

        </div>
      </div>
    </div>
  );
}

export default Tab5;
